import Cookies from 'js-cookie';
import { getDomain } from './domain';

const cookieName = 'utClientId';

export const getUtClientId = () => {
  let id = Cookies.get(cookieName);
  if (!id) {
    id =
      'UT.' +
      Date.now() +
      Math.random()
        .toString()
        .substr(1);
    Cookies.set(cookieName, id, {
      expires: 365 * 2,
      domain: getDomain()
    });
  }
  return id;
};



// WEBPACK FOOTER //
// ./src/utils/utClientId.js